import { useEffect, useMemo, useState } from 'react';
import { useGetLookupTypes } from '../../../hooks/common/useGetLookupTypes';
import AvailableAppointmentsMenuEditing from '../AvailableAppointmentsMenuEditing';
import AvailableAppointmentsMenuStatic from '../AvailableAppointmentsMenuStatic';
import { IUserNextAvailableAppointment } from '../../../hooks/promises/getUserNextAvailableAppointment';
import Spinner from '../../../components/Spinner/Spinner';

interface IAvailableAppointmentsMenuProps {
  nextAvailableAppointment: IUserNextAvailableAppointment | null;
  addUserNextAvailableAppointment: (
    nextAvailableAppointmentId: number
  ) => Promise<void>;
  refetch: () => void;
  thisMonthYear: string;
}

function AvailableAppointmentsMenu({
  addUserNextAvailableAppointment,
  nextAvailableAppointment,
  refetch,
  thisMonthYear,
}: IAvailableAppointmentsMenuProps) {
  const { result: lookupTypes } = useGetLookupTypes();

  const nextAvailableAppointmentOption = useMemo(() => {
    return lookupTypes?.nextAvailableAppointments.find(
      (item) =>
        item.nextAvailableAppointmentId ===
        nextAvailableAppointment?.nextAvailableAppointmentId
    );
  }, [nextAvailableAppointment, lookupTypes]);

  const [editing, setEditing] = useState(false);

  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (nextAvailableAppointment?.nextAvailableAppointmentSet === false) {
      setEditing(true);
    }
  }, [nextAvailableAppointment]);

  if (saving)
    return (
      <div className="flex justify-center">
        <Spinner />
      </div>
    );

  return editing ? (
    <AvailableAppointmentsMenuEditing
      availabilityOptions={lookupTypes.nextAvailableAppointments}
      nextAvailableAppointmentOption={nextAvailableAppointmentOption}
      setEditing={setEditing}
      addUserNextAvailableAppointment={addUserNextAvailableAppointment}
      setSaving={setSaving}
      refetch={refetch}
      thisMonthYear={thisMonthYear}
    />
  ) : (
    <AvailableAppointmentsMenuStatic
      thisMonthYear={thisMonthYear}
      nextAvailableAppointment={
        nextAvailableAppointmentOption?.nextAvailableAppointmentDescription ||
        ''
      }
      setEditingAvailableAppointments={setEditing}
    />
  );
}

export default AvailableAppointmentsMenu;
